
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-18891.52 -23851.965 16.898 16.943"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_160_1","data-name":"Symbol 160 – 1","transform":"translate(-19906.385 -25416.001)","opacity":".74"}},[_c('g',{attrs:{"id":"Group_7743","data-name":"Group 7743","transform":"rotate(45 -1375.116 2019.96)"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3423","d":"M4.423 6.955c1.513 0 2.362-.239 3.079-1.3a3.765 3.765 0 0 0 .345-3.371A1.905 1.905 0 0 0 6.149.691v1.858a1.641 1.641 0 0 1-.292.982 1.575 1.575 0 0 1-1.46.61c-.9 0-1.274-.292-1.46-.61a1.822 1.822 0 0 1-.265-.982V.691a1.944 1.944 0 0 0-1.7 1.593 3.857 3.857 0 0 0 .345 3.371c.744 1.061 1.567 1.3 3.106 1.3z","data-name":"Path 3423"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3424","d":"M10.29 21.8a2.8 2.8 0 0 0-.876 1.858v6.078c0 1.062-.743 1.46-1.646 1.46-.9 0-1.646-.4-1.646-1.46v-6.078a2.733 2.733 0 0 0-.823-1.8","data-name":"Path 3424","transform":"translate(-3.345 -15.509)"}}),_c('ellipse',{attrs:{"id":"Ellipse_891","cx":".717","cy":".717","data-name":"Ellipse 891","rx":".717","ry":".717","transform":"translate(3.707 13.219)","fill":"#444"}})])])])
          )
        }
      }
    